"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientMarshaller = void 0;
const zod_1 = require("zod");
const ZodExtensions_1 = require("./ZodExtensions");
/**
 * Regex to extract the id, id type (optional) and service (optional) from a
 * message recipient address. Expected format is:
 *
 *  <id>@<service>:<id-type>
 *
 */
const addresseeRegex = /^(?<id>.+?)(?:@(?<service>[a-zA-Z0-9]+?)(?::(?<mode>[a-zA-Z0-9]+))?)?$/gm;
const recipientSchemaBase = zod_1.z.object({
    service: zod_1.z.enum(['signalr']).default('signalr'),
});
const recipientSchema = zod_1.z.union([
    zod_1.z.object({
        mode: zod_1.z.literal('connectionid'),
        connectionId: zod_1.z.string().nonempty(),
    }).and(recipientSchemaBase),
    zod_1.z.object({
        mode: zod_1.z.literal('userid'),
        actorType: zod_1.z.string().nonempty(),
        actorName: zod_1.z.string().nonempty(),
        actorId: zod_1.z.string().nonempty(),
        userId: zod_1.z.string().nonempty(),
    }).and(recipientSchemaBase),
    zod_1.z.object({
        mode: zod_1.z.literal('groupname'),
        groupName: zod_1.z.string().nonempty(),
    }).and(recipientSchemaBase),
]);
/* eslint-disable @typescript-eslint/no-explicit-any */
const RecipientMarshaller = (v) => {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    //todo: refactor into superRefine + transform
    return v
        .transform(to => {
        if (ZodExtensions_1.isNullish(to)) {
            return to;
        }
        //extract the recipient address parts
        addresseeRegex.lastIndex = 0; //reset internal state between requests...
        const matches = addresseeRegex.exec(to);
        const { id, service, mode } = matches.groups;
        const modeAsLower = (mode || 'connectionid').toLowerCase();
        switch (modeAsLower) {
            case 'connectionid':
                return {
                    mode: modeAsLower,
                    service,
                    connectionId: id,
                };
            case 'userid':
                {
                    const [type, name, instanceId] = id.split('.');
                    return {
                        mode: modeAsLower,
                        service,
                        actorType: Buffer.from(type, 'base64').toString(),
                        actorName: Buffer.from(name, 'base64').toString(),
                        actorId: Buffer.from(instanceId, 'base64').toString(),
                        userId: `${type}.${name}.${instanceId}`,
                    };
                }
            case 'groupname':
                return {
                    mode: modeAsLower,
                    service,
                    groupName: id,
                };
        }
        return {
            mode,
            service,
            id,
        };
    })
        //ensure extracted address is valid
        .refine(to => (recipientSchema.safeParse(to)).success)
        .transform(to => {
        //coerce it to strongly typed shape
        const result = recipientSchema.safeParse(to);
        // result.success is logically *always* true. There is "else"
        /* istanbul ignore else  */
        if (result.success) {
            return result.data;
        }
        throw result.error;
    });
};
exports.RecipientMarshaller = RecipientMarshaller;
//# sourceMappingURL=ZodRecipientMarshaller.js.map